import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { SelectOption } from "../model/option.interface";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { map, Observable, startWith } from "rxjs";

@Component({
  selector: "app-select-filter",
  templateUrl: "./select-filter.component.html",
  styleUrls: ["./select-filter.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectFilterComponent,
      multi: true,
    },
  ],
})
export class SelectFilterComponent implements OnInit, ControlValueAccessor {
  @Input()
  labelText: string;

  @Input()
  options: SelectOption[];

  @Input()
  disabled: boolean;

  @Input()
  placeholder: string;

  @Input()
  required: boolean;

  @Input()
  submitted: boolean;

  @Input()
  labelWarningGenericText: boolean;

  @Output() model = new EventEmitter<string | SelectOption>();

  onChange!: (value: any) => void;

  myControl = new FormControl("");

  filteredOptions?: Observable<SelectOption[]>;

  constructor(private rf: ChangeDetectorRef) {
    this.disabled = false;
    this.labelText = "";
    this.options = [];
    this.placeholder = "";
    this.required = false;
    this.submitted = false;
    this.labelWarningGenericText = false;
  }
  writeValue(obj: any): void {
    this.model = obj;
    this.rf.detectChanges();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value || ""))
    );
  }  

  getValue() {
    const selectedOption =  this.options.find((option) =>
      option.text.includes(this.myControl.value ?? "")
    )?.value ?? "";
    
    if (selectedOption) {
      this.model.emit(selectedOption);
      this.onChange?.(selectedOption);
    } else {
      // Si el valor no coincide exactamente con una opción, limpiar el campo
      this.myControl.setValue("");
      this.model.emit("");
      this.onChange?.("");
    }
  }
  
  getValueOnKeyDown(event: KeyboardEvent) {
    this.getValue();
  }

  onBlur() {
    this.validateAndSetValue();
  }

  private validateAndSetValue() {
    const currentValue = this.myControl.value ?? "";
    const selectedOption =  this.options.find((option) =>
      option.text.includes(this.myControl.value ?? "")
    )?.value ?? "";

    if (!selectedOption && currentValue) {
      // Si hay un valor pero no coincide con ninguna opción, limpiar el campo
      this.myControl.setValue("");
      this.model.emit("");
      this.onChange?.("");
    }
  }

  private _filter(value: string | number): SelectOption[] {
    const filterValue = value.toString().toLowerCase();
    return this.options.filter((option) =>
      option.text.toLowerCase().includes(filterValue)
    );
  }
}
